const React = require('react');
const PropTypes = require('prop-types');

const { connect } = require('react-redux');

const { formatText, FormattedText } = require('core/i18n').i18n;

const { getCardsForAccountPurchaseDeferral } = require('selectors/cards')

const { CardSelectorRadioButton } = require('components/cards/cardSelectorRadioButton/cardSelectorRadioButton');
const { LoadingSection } = require('commonsComponents/loadingSection');

const { LAVANDA } = require('constants/flagBasedFeatures');

const { 
    getCards,
    selectCard 
} = require('actions/accountPaymentPurchaseDeferral');

class SelectCreditCardPurchaseDeferral extends React.PureComponent {

    componentWillMount() {
        const { getCards, immAccount, immMovement } = this.props
        const product = immAccount.get('product')
        const contractNumber = immAccount.get('contractNumber')
        const amount = immMovement && immMovement.getIn(['balance', 'amount'])
        const currency = immMovement && immMovement.getIn(['balance', 'currency'])

        contractNumber && product && amount && currency && getCards(contractNumber, product, amount, currency)
    }

    onSelect(i, cards){
        const { selectCard } = this.props
        
        return selectCard(cards[i].cardId)
    }

    firstLavandaCards(){
        const { cards, immLavanda } = this.props;
        const lavandaCards = cards.filter(card => {
            return immLavanda.get('cards').includes(card.get('product'));
        });
        const notLavandaCards = cards.filterNot(card => {
            return immLavanda.get('cards').includes(card.get('product'));
        });

        return lavandaCards.concat(notLavandaCards);
    }

    renderContent = () => {
        const {
            cards,
            disablePreLeaveModal,
            immAccount,
            immLavanda,
            lavandaEnabled,
            selectedCard,
        } = this.props
        let content = <LoadingSection />;

        if (!!cards){
            const accountId = immAccount.get('accountId')
            const orderedCards = lavandaEnabled ? this.firstLavandaCards() : cards;
            const orderedCardsJS = orderedCards.toJS();

            content = (
                <CardSelectorRadioButton
                    selected={selectedCard} 
                    cards={orderedCardsJS}
                    accountId={accountId}
                    onChange={(value) => this.onSelect(value, orderedCardsJS)}
                    disablePreLeaveModal={disablePreLeaveModal}
                    lavandaEnabled={lavandaEnabled}
                    immLavanda={immLavanda}
                />
            );
        }
        
        return content;
    }

    render() {
        const { lavandaEnabled } = this.props;

        return (
            <div className="accounts-payment-purchase-deferral__step">

                <div className="accounts-payment-purchase-deferral__step__div-title">
                    <h3 className="accounts-payment-purchase-deferral__step__div-title__title">{formatText("accountPaymentDeferral-cardsTitle")}</h3>
                    <div className="accounts-payment-purchase-deferral__step__div-title__text">
                        <FormattedText value={lavandaEnabled ? "accountPaymentDeferral-lavandaCardsText" : "accountPaymentDeferral-cardsText"}/>
                    </div>
                </div>
                <div className="accounts-payment-purchase-deferral__step__cards-content">
                    {this.renderContent()}
                </div>
            </div>
        )
    }
}

SelectCreditCardPurchaseDeferral.propTypes = {
    getCards: PropTypes.func.isRequired,
    immMovement: PropTypes.object,
    immAccount: PropTypes.object.isRequired,
    immAccountPaymentPurchaseDeferral: PropTypes.object.isRequired,
    immLavanda: PropTypes.object,
    lavandaEnabled: PropTypes.bool,
    showError: PropTypes.bool.isRequired,
    selectCard: PropTypes.func.isRequired,
    selectedCard: PropTypes.string,
    cards: PropTypes.object,
    disablePreLeaveModal: PropTypes.func
};

module.exports.constructor = SelectCreditCardPurchaseDeferral;
module.exports.SelectCreditCardPurchaseDeferral = connect(
	state => ({
        immLavanda: state.cards.getIn(['credit', 'lavanda']),
        lavandaEnabled: state.flagBasedFeatures.get(LAVANDA),
		selectedCard: state.accountPaymentPurchaseDeferralReducer.getIn(['steps', 0, 'selectedCard']),
        cards: getCardsForAccountPurchaseDeferral(state),
        showError: state.accountPaymentPurchaseDeferralReducer.getIn(['steps', 0, 'selectedCardError'])
	}), {
        getCards,
        selectCard
    })(SelectCreditCardPurchaseDeferral);